module.exports = __webpack_public_path__ + "img/new3-img7.aa8b71da.jpg";